import ArkLoader from '@src/js/common/ark-extensions';
import AI_ENTRANCE_COMPONENT from './component-config';
import { IExtension } from '@tencent/ark-extensions';

interface AIEntranceExtension extends IExtension  {
    // TODO: 预期应该由 @tencent/ai-sdk-interface 提供类型
    showAIMenu: (...args: any[]) => void;
    hideAIMenu: () => void;
}

export async function getAIEntranceExtension(): Promise<AIEntranceExtension> {
    await ArkLoader.initPromise;
    const aiEntranceExtension = await ArkLoader.extensionService.getExtension(AI_ENTRANCE_COMPONENT.name);
    return aiEntranceExtension as any;
}
